export const REQUEST_MASTER_USER = 'REQUEST_MASTER_USER';
export const SET_MASTER_USER = 'SET_MASTER_USER';
export const ERROR_GET_MASTER_USER = 'ERROR_GET_MASTER_USER';
export const SET_MESSAGE_MASTER_USER = 'SET_MESSAGE_MASTER_USER';
